import React, { useState } from "react";
import { 
  ArrowLeft, Leaf, ChevronRight, Check, Target, Calendar, Award,
  ArrowRight, Sparkles, FileText, Eye, TrendingUp
} from "lucide-react";

const ComoLoHacemos = ({ onContinue, onBack, clientData }) => {
  const [activeFase, setActiveFase] = useState(0);

  const fases = [
    {
      id: 'previo',
      titulo: 'PREVIO A LA PRUEBA',
      subtitulo: 'Definimos dónde está el mayor impacto',
      icono: <Target className="w-6 h-6" />,
      color: 'from-blue-500 to-indigo-500',
      puntos: [
        { texto: 'Selección estratégica de vehículos', detalle: '(km + consumo = máximo potencial CAES)' },
        { texto: 'Recogida de documentación base', detalle: null },
        { texto: 'Nombramiento de líder operativo', detalle: 'con capacidad real de actuación' }
      ],
      mensaje: 'Aquí se garantiza que el ahorro será certificable.'
    },
    {
      id: 'f1',
      titulo: 'F1 – FOTO INICIAL',
      subtitulo: '"Tu realidad"',
      icono: <Eye className="w-6 h-6" />,
      color: 'from-emerald-500 to-teal-500',
      puntos: [
        { texto: 'Consumo real', detalle: null },
        { texto: 'Estilo de conducción', detalle: null },
        { texto: 'Desviaciones operativas', detalle: null }
      ],
      mensaje: 'Se construye la línea base energética.',
      extra: 'Reunión de cierre F1: Decidimos las actuaciones concretas de mejora.'
    },
    {
      id: 'f2',
      titulo: 'F2 – OPTIMIZACIÓN',
      subtitulo: '"Donde nace el ahorro"',
      duracion: 'hasta completar 90 días F1+F2',
      icono: <TrendingUp className="w-6 h-6" />,
      color: 'from-amber-500 to-orange-500',
      puntos: [
        { texto: 'Seguimiento diario', detalle: null },
        { texto: 'Interacción directa con conductores', detalle: null },
        { texto: 'Corrección inmediata de desviaciones', detalle: null }
      ],
      resultados: [
        { icono: '👤', texto: 'El líder operativo ejecuta.' },
        { icono: '📉', texto: 'El consumo baja.' },
        { icono: '💰', texto: 'El ahorro aparece.' }
      ]
    },
    {
      id: 'caes',
      titulo: 'CERTIFICACIÓN CAES',
      subtitulo: 'No es una fase técnica. Es la monetización.',
      icono: <Award className="w-6 h-6" />,
      color: 'from-green-500 to-emerald-600',
      puntos: [
        { texto: 'Cálculo validado', detalle: null },
        { texto: 'Documentación justificativa', detalle: null },
        { texto: 'Conversión del ahorro en ingreso', detalle: null }
      ],
      mensaje: null
    }
  ];

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      {/* Header */}
      <div className="bg-gradient-to-r from-emerald-600 via-emerald-700 to-green-700 text-white py-4 shadow-xl sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
          <div className="flex items-center gap-4">
            <button onClick={onBack} className="p-2 hover:bg-white/20 rounded-lg transition-all" data-testid="back-from-proceso-btn">
              <ArrowLeft className="w-5 h-5" />
            </button>
            <img
              src="/logo-mobilsafe.png"
              alt="MOBILSAFE"
              className="h-9 md:h-10 bg-white/95 rounded px-2 py-1"
              onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }}
            />
            <div className="hidden items-center gap-2">
              <div className="w-9 h-9 bg-white/15 backdrop-blur rounded-lg flex items-center justify-center border border-white/30">
                <Leaf className="w-5 h-5 text-white" />
              </div>
              <div className="leading-tight">
                <p className="text-base font-black tracking-tight text-white">MOBILSAFE</p>
                <p className="text-[9px] text-emerald-100 tracking-widest font-semibold">FLEET TECHNOLOGY</p>
              </div>
            </div>
            <div className="border-l border-white/30 pl-4">
              <h1 className="text-xl font-black">Cómo lo Conseguimos</h1>
              <p className="text-emerald-200 text-sm">{clientData?.empresa} • Proceso CAES MOBILSAFE</p>
            </div>
          </div>
          <button onClick={onContinue} className="px-6 py-2.5 bg-white/20 hover:bg-white/30 rounded-lg font-bold transition-all flex items-center gap-2" data-testid="skip-proceso-btn">
            Ver Resultados <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-8">
        {/* Título principal */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-black mb-3 text-slate-900">
            De consumo oculto a <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-500 to-green-600">ingreso certificado</span>
          </h2>
          <p className="text-emerald-700 text-lg">El proceso que garantiza resultados reales</p>
        </div>

        {/* Timeline horizontal */}
        <div className="flex justify-between items-center mb-8 relative">
          <div className="absolute top-1/2 left-0 right-0 h-1 bg-emerald-200 -translate-y-1/2 z-0"></div>
          {fases.map((fase, idx) => (
            <button
              key={fase.id}
              onClick={() => setActiveFase(idx)}
              className={`relative z-10 flex flex-col items-center gap-2 transition-all ${activeFase === idx ? 'scale-110' : 'opacity-70 hover:opacity-100'}`}
              data-testid={`fase-btn-${fase.id}`}
            >
              <div className={`w-14 h-14 rounded-full bg-gradient-to-br ${fase.color} flex items-center justify-center shadow-lg ${activeFase === idx ? 'ring-4 ring-emerald-200' : ''}`}>
                {fase.icono}
              </div>
              <span className={`text-xs font-bold text-center max-w-[80px] ${activeFase === idx ? 'text-slate-900' : 'text-slate-500'}`}>
                {fase.id === 'previo' ? 'PREVIO' : fase.id === 'caes' ? 'CAES' : fase.id.toUpperCase()}
              </span>
            </button>
          ))}
        </div>

        {/* Contenido de fase activa */}
        <div className="bg-white border border-slate-200 rounded-3xl p-8 mb-8 transition-all shadow-sm">
          <div className="flex items-start gap-4 mb-6">
            <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${fases[activeFase].color} flex items-center justify-center shadow-xl`}>
              {fases[activeFase].icono}
            </div>
            <div>
              <h3 className="text-2xl font-black text-slate-900">{fases[activeFase].titulo}</h3>
              <p className="text-emerald-700 text-lg">{fases[activeFase].subtitulo}</p>
              {fases[activeFase].duracion && (
                <p className="text-amber-600 text-sm font-medium mt-1">⏱ {fases[activeFase].duracion}</p>
              )}
            </div>
          </div>

          {/* Puntos de la fase */}
          <div className="space-y-3 mb-6">
            {fases[activeFase].id === 'f1' && (
              <p className="text-emerald-700 font-medium mb-4">Medimos sin intervenir:</p>
            )}
            {fases[activeFase].puntos.map((punto, idx) => (
              <div key={idx} className="flex items-start gap-3 bg-slate-50 border border-slate-100 rounded-xl p-4">
                <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="w-4 h-4 text-emerald-600" />
                </div>
                <div>
                  <p className="font-semibold text-slate-900">{punto.texto}</p>
                  {punto.detalle && <p className="text-slate-600 text-sm">{punto.detalle}</p>}
                </div>
              </div>
            ))}
          </div>

          {/* Resultados especiales de F2 */}
          {fases[activeFase].resultados && (
            <div className="grid md:grid-cols-3 gap-4 mb-6">
              {fases[activeFase].resultados.map((res, idx) => (
                <div key={idx} className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-center">
                  <span className="text-3xl mb-2 block">{res.icono}</span>
                  <p className="font-bold text-slate-900">{res.texto}</p>
                </div>
              ))}
            </div>
          )}

          {/* Mensaje de la fase */}
          {fases[activeFase].mensaje && (
            <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4">
              <p className="text-emerald-800 font-medium flex items-center gap-2">
                <span className="text-xl">📊</span> {fases[activeFase].mensaje}
              </p>
            </div>
          )}

          {/* Extra de F1 */}
          {fases[activeFase].extra && (
            <div className="mt-4 bg-blue-50 border border-blue-200 rounded-xl p-4">
              <p className="text-blue-800 font-medium flex items-center gap-2">
                <span className="text-xl">🤝</span> {fases[activeFase].extra}
              </p>
            </div>
          )}
        </div>

        {/* Navegación entre fases */}
        <div className="flex justify-between items-center mb-10">
          <button
            onClick={() => setActiveFase(Math.max(0, activeFase - 1))}
            disabled={activeFase === 0}
            className="px-4 py-2 bg-white border border-slate-200 hover:bg-slate-100 rounded-lg font-semibold flex items-center gap-2 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-700"
          >
            <ArrowLeft className="w-4 h-4" /> Anterior
          </button>
          <div className="flex gap-2">
            {fases.map((_, idx) => (
              <div key={idx} className={`w-2 h-2 rounded-full transition-all ${idx === activeFase ? 'bg-emerald-500 w-6' : 'bg-slate-300'}`} />
            ))}
          </div>
          <button
            onClick={() => setActiveFase(Math.min(fases.length - 1, activeFase + 1))}
            disabled={activeFase === fases.length - 1}
            className="px-4 py-2 bg-white border border-slate-200 hover:bg-slate-100 rounded-lg font-semibold flex items-center gap-2 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-700"
          >
            Siguiente <ChevronRight className="w-4 h-4" />
          </button>
        </div>

        {/* Mensaje resumen */}
        <div className="bg-gradient-to-r from-emerald-50 via-green-50 to-teal-50 border border-emerald-200 rounded-3xl p-8 text-center mb-8">
          <h4 className="text-xl font-black text-emerald-700 mb-4">🎯 MENSAJE CLAVE</h4>
          <p className="text-lg text-slate-800 mb-4">
            <strong>F1 y F2 son las etapas críticas.</strong><br />
            Sin medición rigurosa y liderazgo operativo, no hay ahorro.
          </p>
          <div className="flex flex-wrap justify-center gap-4 mt-6">
            <div className="bg-white border border-slate-200 rounded-xl px-5 py-3 shadow-sm">
              <p className="text-emerald-600 text-sm font-medium">Primero</p>
              <p className="text-slate-900 font-bold">medimos tu realidad</p>
            </div>
            <div className="text-2xl flex items-center text-slate-400">→</div>
            <div className="bg-white border border-slate-200 rounded-xl px-5 py-3 shadow-sm">
              <p className="text-amber-600 text-sm font-medium">Después</p>
              <p className="text-slate-900 font-bold">la optimizamos</p>
            </div>
            <div className="text-2xl flex items-center text-slate-400">→</div>
            <div className="bg-white border border-slate-200 rounded-xl px-5 py-3 shadow-sm">
              <p className="text-green-600 text-sm font-medium">Finalmente</p>
              <p className="text-slate-900 font-bold">la convertimos en dinero</p>
            </div>
          </div>
        </div>

        {/* Botón principal */}
        <div className="text-center">
          <button
            onClick={onContinue}
            className="px-12 py-4 bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-700 hover:to-green-700 text-white text-xl font-black rounded-xl shadow-2xl transition-all transform hover:scale-105 flex items-center gap-3 mx-auto"
            data-testid="view-results-from-proceso-btn"
          >
            <Leaf className="w-6 h-6" /> Ver Impacto Sostenible
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComoLoHacemos;
